import { DepInjMixin, requires } from '@APP/mixins/dependency';
import { QuestionsService } from '@APP/services/questions-service';
import { UserService } from '../../services/user-service';
import { css, html } from 'lit';
import { customElement } from 'lit/decorators';
import { commonPopupMobileStyle, commonPopupStyle } from '../../styles/common-style';
import { t } from '../../utils/locale';
import { DeviceAwareComponent } from '../components/device-aware-component';
import { GoodMessage } from '../icons/icons';

type OwnDeps = {
  questionsService: QuestionsService;
  userService: UserService;
};
@requires(QuestionsService.serviceName, UserService.serviceName)
@customElement('welcome-new-user-popup')
export class WelcomePopup extends DepInjMixin<OwnDeps>(DeviceAwareComponent) {
  static get mobileStyles() {
    return [commonPopupMobileStyle];
  }
  static get baseStyles() {
    return [
      commonPopupStyle,
      css`
    .grid-container{
      display:grid;
      margin:auto;
    }
    .title{
      font-weight:700;
      font-size:4rem;
      margin-bottom:4.75rem;
    }
     .message {
      font-weight: 400;
      max-width:var(--message-max-width, 39rem);
      color: var(--c-text);
    }

      h2:last-of-type{
      margin-bottom: 2rem;
    }
   `,
    ];
  };

  renderMobileLayout() {
    const username = this.deps.userService.getNameTitle();
    const watercraftName = this.deps.questionsService.model.getBoatDisplayName();


    return html`
      <div class="grid-container">
       <div class="col-1">
         <h1 class="title">${t('T_Welcome_New_User1')} ${username ? username : ''}</h1>
       </div>
       <div class="col-2">
        ${GoodMessage}
      </div>
      <div class="col-3">
        <h2 class="message">${t('T_Welcome_New_User2', watercraftName)} ${t('T_Welcome_New_User3')}</h2>
      </div>
     </div>
    `;
  }

  renderDesktopLayout() {
    const username = this.deps.userService.getNameTitle();
    const watercraftName = this.deps.questionsService.model.getBoatDisplayName();

    return html`
     <div class="grid-container">
       <div class="col-1"></div>
       <div class="col-2">
        <h1 class="title">${t('T_Welcome_New_User1')} ${username ? username : ''}</h1>
        <h2 class="message">${t('T_Welcome_New_User2', watercraftName)} ${t('T_Welcome_New_User3')}</h2>
      </div>
     </div>
    `;
  }

  renderContent() {
    return this.userDevice === 'desktop' ? this.renderDesktopLayout() : this.renderMobileLayout();
  }
}
